function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.655 5.771a1.5 1.5 0 00-1.9 1.445v7.161a7.031 7.031 0 001.811 4.778 15.281 15.281 0 005.922 4 1.5 1.5 0 001.033 0 15.267 15.267 0 005.923-4 7.031 7.031 0 001.811-4.778V7.216a1.5 1.5 0 00-1.905-1.445 23.131 23.131 0 01-12.695 0z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.25 4.035V2.25a1.5 1.5 0 00-1.9-1.445 23.112 23.112 0 01-12.69 0A1.5 1.5 0 00.75 2.25v7.162a7.031 7.031 0 001.811 4.778c.171.186.353.374.544.563M18 15.75a3 3 0 01-6 0m-2.25-4.5a1.5 1.5 0 013 0m4.5 0a1.5 1.5 0 013 0",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgShowTheaterMasks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgShowTheaterMasks;